import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {
  ClientDocumentFileDto,
  DeleteClientDocumentRequestDto,
  RenameClientDocumentDto,
} from "../models/project-workflow/clientDocumentFileDto";
import { GenericResponseDto } from "../models/generic-response.dto";

@Injectable({
  providedIn: "root",
})
export class ClientDocumentService {
  private clientDocumentBaseURL = environment.baseUrl + "/ClientDocument";

  constructor(private _http: HttpClient) {}

  /** Saves client document metadata after blob upload. */
  saveClientDocument(
    payload: ClientDocumentFileDto
  ): Observable<GenericResponseDto<number>> {
    return this._http.post<GenericResponseDto<number>>(
      this.clientDocumentBaseURL + "/AddClientDocument",
      payload
    );
  }

  /** Gets all client documents for a workflow. */
  getClientDocuments(
    workflowId: number
  ): Observable<GenericResponseDto<ClientDocumentFileDto[]>> {
    return this._http.get<GenericResponseDto<ClientDocumentFileDto[]>>(
      this.clientDocumentBaseURL +
        `/GetClientDocuments?WorkflowId=${workflowId}`
    );
  }

  /** Deletes a client document record. */
  deleteClientDocument(
    request: DeleteClientDocumentRequestDto
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.clientDocumentBaseURL + "/DeleteClientDocument",
      request
    );
  }

  /** Renames a client document. */
  renameClientDocument(
    request: RenameClientDocumentDto
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.clientDocumentBaseURL + "/RenameClientDocument",
      request
    );
  }

  /** Edits a client document link. */
  editClientDocumentLink(
    payload: ClientDocumentFileDto
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.clientDocumentBaseURL + "/EditClientDocumentLink",
      payload
    );
  }
}
